export default __webpack_public_path__ + "1de5fac8db0c5fc5f0cde2352cc89527.mp3";